import { signal } from 'services/SignalsService'
import { reelsSettings } from 'settings/custom/reels'

const name = 'WIN-SCATTER'

function execute() {

  if(!reelsSettings.items.hasOwnProperty('scatterAnim')){
    return Promise.resolve()
  }
  const freeSpinModel = game.models.FreespinModel.get()
  if(freeSpinModel.left && freeSpinModel.add){
    signal.dispatch('WIN-SCATTER-ANIM', true)
  }
  else {
    return Promise.resolve()
  }

  return signal.promise('WIN-SCATTER-ANIM:DONE')
}

export function getWinScatterAction() {
  return {
    name,
    execute,
  }
}
